import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface HelpSlice {
  isOpen: boolean;
  selectedSectionId?: string;
}

const initialState: HelpSlice = {
  isOpen: false,
  selectedSectionId: undefined,
};

export const helpSlice = createSlice({
  name: "help",
  initialState: initialState,
  reducers: {
    openHelp: (state, action: PayloadAction<string | undefined>) => {
      state.isOpen = true;
      state.selectedSectionId = action.payload;
    },
    closeHelp: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openHelp, closeHelp } = helpSlice.actions;

export default helpSlice.reducer;
